var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group",attrs:{"id":"serviceTypeFormCart"}},[_vm._l((_vm.serviceTypeFormConfig),function(item,key){return [_c(_vm.getFormInputComponent(item),{tag:"component",attrs:{"item":item,"restaurant":_vm.restaurant}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }